import React, { Component } from 'react';
import { Form, Input, Button, message } from 'antd';
import { PostForm } from '../../utils/http';
import cookie from '../../utils/cookie';
import cn from './index.module.css';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onFinish = ({ username, password }) => {
    this.setState({ loading: true });
    PostForm({
      url: '/api/user/login',
      data: { username, password },
      success: ({ data = {} }) => {
        cookie.set('u', data.username, { maxage: 8 * 24 * 60 * 60 * 1000 })
        cookie.set('a', data.auth.join(), { maxage: 8 * 24 * 60 * 60 * 1000 });
        message.success('登录成功');
        this.props.history.push('/');
      },
      error: () => {
        message.error('登录失败');
      },
      final: () => {
        this.setState({ loading: false });
      },
    });
  }
  render() {
    const { loading } = this.state;
    return (
      <div className={cn.root}>
        <Form
          {...layout}
          className={cn.login}
          name="basic"
          onFinish={this.onFinish}
        >
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: '请输入用户名!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item style={{ textAlign: 'center', margin: 'auto' }}>
            <Button loading={loading} type="primary" htmlType="submit">
              提交
          </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default Login;
